<div class="email-sent-image">
  @if (status() === 'verify') {
    <img [src]="verifyImg" alt="" />
  } @else {
    <mat-icon
      [ngClass]="status() === 'succeeded' ? 'icon-check1' : 'icon-error'"
      [class.error]="status() !== 'succeeded'">
    </mat-icon>
  }
</div>

<h1 class="mat-h2">{{ title() }}</h1>

<p [innerHTML]="subtitle()"></p>

@if (routerLinkAction()) {
  <a mat-flat-button [color]="'primary'" [routerLink]="routerLinkAction().routerLink">
    {{ routerLinkAction().text | async }}
  </a>
}

@if (clickActionText()) {
  <accredible-button-loading
    [isLoading]="isLoading()"
    [btnText]="clickActionText()"
    (click)="clickAction.emit()">
  </accredible-button-loading>
}
